<template>
    <div class="modal-wrapper" :class="{hide: !modals.openNewTabDeposits}" v-on:click.stop="hideModal">
        <div class="modal" @click.stop>
            <div class="title">
                <h4 class="title__large">{{ 'Open in a new tab ?' }}</h4>
                <i class="material-icons pointer" @click="hideModal">close</i>
            </div>
            <div class="row">
                <p class="url">
                    {{ modalOpenNewTabDeposits.url }}
                </p>
            </div>
            <div class="row">
                <div class="col">
                    <span class="button bg-light-button" @click="copyUrl">{{ 'Copy' }}</span>
                </div>
                <div class="col">
                    <span class="button green-button" @click="openNewTab">{{ 'Open New Tab' }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import {MODAL, MODAL_OPEN_NEW_TAB_DEPOSIT, NOTIFICATION} from '@/store/mutations.type'

export default {
    name: "OpenNewTabDepositsModal",
    methods: {
        hideModal() {
            this.$store.commit(MODAL, {
                openNewTabDeposits: false
            })
            this.$store.commit(MODAL_OPEN_NEW_TAB_DEPOSIT, null)
        },
        copyUrl() {
            let url = this.modalOpenNewTabDeposits.url;

            if(url){
                navigator.clipboard.writeText(url)
                    .then(() => {
                        this.$store.commit(NOTIFICATION, 'Address copied to clipboard')
                    })
                    .catch(() => {
                    })
            }
        },
        openNewTab() {
            let url = this.modalOpenNewTabDeposits.url;

            if(url){
                let win = window.open(url, '_blank');
                if (win) {
                    win.focus()
                }
            }

            this.hideModal()
        },
    },
    computed: {
        ...mapGetters(['modals', 'tokens','modalOpenNewTabDeposits']),
    }
}
</script>

<style scoped>
.modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal {
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: var(--background-dark);
    padding: 25px;
    border: 1px solid var(--border);
    z-index: 1100;
}

.title {
    color: var(--white-to-black);
    font-weight: 600;
    font-size: 1.1em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.title i {
    font-size: 20px;
}

.col {
    flex: 1 1 50%;
    justify-content: flex-start;
    line-height: 1.5;
}

.col:first-child {
    margin-right: 30px;
}

label {
    margin-bottom: 5px;
}

input {
    width: 100%;
}

.row {
    overflow: hidden;
    align-items: stretch;
    flex-wrap: nowrap;
}

.button {
    width: 100%;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
    font-weight: 600;
    cursor: pointer;
}

.red-button {
    color: var(--white);
    background-color: #ac4343;
}

.bg-light-button {
    color: var(--white);
    background-color: var(--background-light);
}

.url{
    word-break: break-all;
}

</style>
